//----------------------------------------------------Library
import React from "react";
import { Grid, Typography, Button, CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
//----------------------------------------------------redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AccountActions from "../Actions/AccountActions";
import * as ProcessActions from "../Actions/ProcessActions";
//----------------------------------------------------Utils
import { verifyEmailAddress } from "../Utils/MFA";

const styles = (theme) => ({
  nextBtn: {
    margin: "20px 0 10px 0",
    height: "3rem",
    backgroundColor: '#155E98',
  },
});

const StepThree = (props) => {

  const resendEmailVerification = async () => {
    const { actions, openSnackbar, userAccount } = props;
    actions.setLoading(true);
    const result = await verifyEmailAddress(userAccount.email, userAccount.hashedPassword);

    if (result.ok) {
      openSnackbar(null);
      openSnackbar({
        type: "success",
        open: true,
        message: `Verification email has been send to your email address ${userAccount.email}, please check your email`,
        duration: 4000
      });
    } else {
      openSnackbar(null);
      openSnackbar({
        type: "error",
        open: true,
        message: result.msg || 'Something went wrong. Please try again',
        duration: 4000
      });
    }
    actions.setLoading(false);
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ paddingBottom: "6px", marginBottom: "5px" }}>
        <Typography variant="h4" gutterBottom><strong>Account Created</strong></Typography>
      </Grid>
      <Grid item xs={12}>
        Thanks for creating an account with Trade View Technologies, Please check your email for verify your email address
      </Grid>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={resendEmailVerification}
        className={props.classes.nextBtn}
      >
        {props.loading ? <CircularProgress size={20} color='inherit' >&nbsp;Please Wait...</CircularProgress> : <Typography variant="h5">Re-send email</Typography>}
      </Button>
    </Grid>
  )
}

const mapStateToProps = ({ process, accountReducer }) => ({
  loading: process.loading,
  userAccount: accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ProcessActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepThree));